var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 14,
    height: 14,
    baseProfile: "tiny",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.9.4c.7-.8 1.8-.4 2.2 0 .1.1.7.8 1.5 1.5.4.4.7 1.5 0 2.3s-7.7 7.9-7.7 7.9c-1.5 1.5-3.6.8-4.7-.4C.1 10.6-.6 8.3.8 6.8c.7-.8 4.7-4.9 4.7-4.9l.7.8-4.3 4.5c-1.5 1.5-.6 3.2 0 3.8s2.2 1.5 3.6 0c1.1-1.1 6.9-7.2 6.9-7.2.7-.8 0-1.5 0-1.5l-.7-.8c-.7-.8-1.5 0-1.5 0L4.1 8s-.7.8-.4 1.1c.4.4 1.1-.4 1.1-.4l5.8-6 .7.8-6.1 6.4S4.1 11 3 9.9s0-2.3 0-2.3z"
  })));
});
const SvgPaperClipIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaperClipIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4yIiBiYXNlUHJvZmlsZT0idGlueSIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTkuOSAwLjRjMC43LTAuOCAxLjgtMC40IDIuMiAwYzAuMSAwLjEgMC43IDAuOCAxLjUgMS41YzAuNCAwLjQgMC43IDEuNSAwIDIuMyBjLTAuNyAwLjgtNy43IDcuOS03LjcgNy45Yy0xLjUgMS41LTMuNiAwLjgtNC43LTAuNGMtMS4xLTEuMS0xLjgtMy40LTAuNC00LjljMC43LTAuOCA0LjctNC45IDQuNy00LjlsMC43IDAuOEwxLjkgNy4yIGMtMS41IDEuNS0wLjYgMy4yIDAgMy44YzAuNiAwLjYgMi4yIDEuNSAzLjYgMGMxLjEtMS4xIDYuOS03LjIgNi45LTcuMmMwLjctMC44IDAtMS41IDAtMS41bC0wLjctMC44Yy0wLjctMC44LTEuNSAwLTEuNSAwTDQuMSA4IGMwIDAtMC43IDAuOC0wLjQgMS4xYzAuNCAwLjQgMS4xLTAuNCAxLjEtMC40bDUuOC02bDAuNyAwLjhMNS4yIDkuOWMwIDAtMS4xIDEuMS0yLjIgMEMxLjkgOC44IDMgNy42IDMgNy42TDkuOSAwLjR6Ii8+Cjwvc3ZnPg==";